import React from "react";
import { Stack } from "@mui/joy";
import MoreInfoButton from "../MoreInfoButton/MoreInfoButton";
import { SxProps } from "@mui/joy/styles/types";

type Props = {
  type: "list-icon" | "list-menu";
  sx?: SxProps;
};
const Menus = ({ type }: Props) => {
  const isMenu = type == "list-menu";
  return (
    <>
      <MoreInfoButton useIconButton={isMenu} />
    </>
  );
};

const ListInfoMenu = ({ type, sx }: Props) => {
  return (
    <>
      {type == "list-icon" && (
        <Stack
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
            ...(sx || {}),
          }}
        >
          <Menus type={type} />
        </Stack>
      )}
      {type == "list-menu" && (
        <Stack
          sx={{
            display: { xs: "grid", md: "none" },
            justifyItems: "start",
            "& > * ": { px: 2, py: 1, width: 1, justifyContent: "start" },
            ...(sx || {}),
          }}
        >
          <Menus type={type} />
        </Stack>
      )}
    </>
  );
};

export default ListInfoMenu;
